import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ViewFilterPipe } from './filter.pipe';
import { NumberFormatPipe } from './number.pipe';
import { SanitizePipe } from './sanitize.pipe';

@NgModule({
  imports: [TranslateModule, CommonModule],
  declarations: [ViewFilterPipe, SanitizePipe, NumberFormatPipe],
  providers: [TranslatePipe],
  exports: [ViewFilterPipe, SanitizePipe, TranslatePipe, NumberFormatPipe],
})
export class SharedModule {}
